import { useEffect } from 'react';

interface Usable {
    use(): void;
    unuse(): void;
}

export default function useStylesheets(...styles: Usable[]): void {
    useEffect(() => {
        styles.forEach((it) => it.use());

        return () => styles.forEach((it) => it.unuse());
    }, []);
}
